/** Default route to send users to after authentication when no explicit redirect is set. */
export const POST_AUTH_REDIRECT = '/search';
